import { defineMaterial, type MaterialComponentProps } from '@h5/schema';
import { ButtonPropsSchema, type ButtonProps } from './schema';

export { ButtonPropsSchema, type ButtonProps };

/** 按钮物料：不绑 onClick，点击动作由外层图层事件系统（layer.events）处理。 */
function ButtonView({ props }: MaterialComponentProps<ButtonProps>) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: props.bgColor,
        color: props.color,
        fontSize: props.fontSize,
        borderRadius: props.radius,
        border: `1px solid ${props.borderColor}`,
        cursor: 'pointer',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {props.text}
    </div>
  );
}

export const buttonMaterial = defineMaterial<ButtonProps>({
  id: 'button',
  version: 1,
  name: '按钮',
  category: 'basic',
  icon: '⬭',
  defaultSize: { w: 160, h: 44 },
  defaultProps: ButtonPropsSchema.parse({}),
  propsSchema: ButtonPropsSchema,
  component: ButtonView,
});
